(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1407],{

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3873);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 3510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tug/mva",
      function () {
        return __webpack_require__(73232);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Container(_param) {
    var children = _param.children, fluid = _param.fluid, classNameInput = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "fluid",
        "className"
    ]);
    var className = "PingCAPContainer";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, classNameInput, (_obj = {}, _defineProperty(_obj, "".concat(className, "-fluid"), fluid), _defineProperty(_obj, "".concat(className, "-normal"), !fluid), _obj))
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 75532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(580);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function MyLink(_param) {
    var to = _param.to, href = _param.href, children = _param.children, rest = _objectWithoutProperties(_param, [
        "to",
        "href",
        "children"
    ]);
    return href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, rest, {
        href: href,
        children: children
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({}, rest, {
        href: to,
        children: children
    }));
};


/***/ }),

/***/ 73232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/ArrowRightOutlined.js
// This icon file is generated automatically.
var ArrowRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" } }] }, "name": "arrow-right", "theme": "outlined" };
/* harmony default export */ var asn_ArrowRightOutlined = (ArrowRightOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/ArrowRightOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var ArrowRightOutlined_ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_ArrowRightOutlined
  }));
};

ArrowRightOutlined_ArrowRightOutlined.displayName = 'ArrowRightOutlined';
/* harmony default export */ var icons_ArrowRightOutlined = (/*#__PURE__*/react.forwardRef(ArrowRightOutlined_ArrowRightOutlined));
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/components/mva/BecomeMVA.module.scss
var BecomeMVA_module = __webpack_require__(92593);
var BecomeMVA_module_default = /*#__PURE__*/__webpack_require__.n(BecomeMVA_module);
;// CONCATENATED MODULE: ./src/components/mva/BecomeMVA.jsx



function BecomeMVA(param) {
    var iconUrl = param.iconUrl, title = param.title, summary = param.summary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BecomeMVA_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BecomeMVA_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: iconUrl,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BecomeMVA_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BecomeMVA_module_default()).summary,
                children: summary
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Container/Container.tsx
var Container = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/MyLink.jsx
var MyLink = __webpack_require__(75532);
// EXTERNAL MODULE: ./src/components/mva/MVAItem.module.scss
var MVAItem_module = __webpack_require__(60850);
var MVAItem_module_default = /*#__PURE__*/__webpack_require__.n(MVAItem_module);
;// CONCATENATED MODULE: ./src/components/mva/MVAItem.jsx






function MVAItem(param) {
    var name = param.name, company = param.company, title = param.title, links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MVAItem_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MVAItem_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MVAItem_module_default()).avatar,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            unoptimized: true,
                            src: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/avatar/".concat(encodeURIComponent(name), ".jpg")),
                            alt: name,
                            width: 100,
                            height: 100
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MVAItem_module_default()).name,
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MVAItem_module_default()).organization,
                        children: company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MVAItem_module_default()).position,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MVAItem_module_default()).hover,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: (MVAItem_module_default()).links,
                    children: links.map(function(link, index) {
                        return link.href && (link.href === "#" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: link.name
                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLink/* default */.Z, {
                                href: link.href,
                                children: link.name
                            })
                        }, index));
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/mva/WelfareItem.module.scss
var WelfareItem_module = __webpack_require__(95204);
var WelfareItem_module_default = /*#__PURE__*/__webpack_require__.n(WelfareItem_module);
;// CONCATENATED MODULE: ./src/components/mva/WelfareItem.jsx



function WelfareItem(param) {
    var iconUrl = param.iconUrl, name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (WelfareItem_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WelfareItem_module_default()).wireframe
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WelfareItem_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (WelfareItem_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: iconUrl,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (WelfareItem_module_default()).name,
                        children: name
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/mva/YearSwitch.module.scss
var YearSwitch_module = __webpack_require__(8940);
var YearSwitch_module_default = /*#__PURE__*/__webpack_require__.n(YearSwitch_module);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/mva/YearSwitch.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





function YearSwitch(param) {
    var onClick = param.onClick, items = param.items, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (YearSwitch_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (YearSwitch_module_default()).label,
                children: "\u5E74\u4EFD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(space/* default */.Z, {
                className: (YearSwitch_module_default()).options,
                size: 16,
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((YearSwitch_module_default()).options_item, _defineProperty({}, (YearSwitch_module_default()).options_item_selected, value === item.value)),
                        onClick: function() {
                            return onClick(item.value);
                        },
                        children: item.name
                    }, index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/pages/tug/mva/mva.module.scss
var mva_module = __webpack_require__(5999);
var mva_module_default = /*#__PURE__*/__webpack_require__.n(mva_module);
;// CONCATENATED MODULE: ./src/pages/tug/mva/data/mva2019.js
var data = [
    {
        name: "\u4F55\u5FD7\u52C7",
        company: "\u5E73\u5B89\u79D1\u6280",
        title: "\u8D44\u6DF1\u4E91\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB \u5728\u5E73\u5B89\u6838\u5FC3\u7CFB\u7EDF\u7684\u5F15\u5165\u53CA\u5E94\u7528",
                href: "https://pingcap.com/cases-cn/user-case-pingankeji/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5E73\u5B89\u7684\u5E94\u7528\u5B9E\u6218",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011\u5206\u8FDB\u5408\u51FB\u2014\u2014\u5206\u5E03\u5F0F\u6570\u636E\u5E93\u5728\u5E73\u5B89\u5E94\u7528\u5B9E\u6218",
                href: "https://dbaplus.cn/activity-48-759-1.html"
            }, 
        ]
    },
    {
        name: "\u5B59\u6653\u5149",
        company: "\u77E5\u4E4E",
        title: "\u6280\u672F\u5E73\u53F0\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u77E5\u4E4E\u4E07\u4EBF\u91CF\u7EA7\u4E1A\u52A1\u6570\u636E\u4E0B\u7684\u5B9E\u8DF5\u548C\u6311\u6218",
                href: "https://mp.weixin.qq.com/s/AdxZY0FVYGkTos0F5LOfzw"
            },
            {
                name: "\u77E5\u4E4E\u5DF2\u8BFB\u670D\u52A1\u7684\u524D\u751F\u4ECA\u4E16\u4E0E\u672A\u6765",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/312"
            },
            {
                name: "TiDB PD \u7EC4\u4EF6\u4EE3\u7801\u9605\u8BFB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-pd/1388"
            },
            {
                name: "\u62E5\u62B1 Elasticsearch\uFF1A\u7ED9 TiDB \u63D2\u4E0A\u5168\u6587\u68C0\u7D22\u7684\u7FC5\u8180",
                href: "https://mp.weixin.qq.com/s/TWi4ZbTrsnbie4C6Vdjt-A"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u77E5\u4E4E\u4E07\u4EBF\u91CF\u7EA7\u4E1A\u52A1\u6570\u636E\u4E0B\u7684\u5B9E\u8DF5\u548C\u6311\u6218",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011\u77E5\u4E4E\u5DF2\u8BFB\u670D\u52A1\u67B6\u6784\u6F14\u8FDB",
                href: "https://mp.weixin.qq.com/s/9pOVJUHqgJgfdUQRUvm67w"
            }, 
        ]
    },
    {
        name: "\u5F20\u4FCA\u9A8F",
        company: "\u5C0F\u7EA2\u4E66",
        title: "\u6570\u636E\u5E93\u4E0E\u4E2D\u95F4\u4EF6\u56E2\u961F\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u5C0F\u7EA2\u4E66\u4ECE 0 \u5230 200+ \u8282\u70B9\u7684\u63A2\u7D22\u548C\u5E94\u7528",
                href: "https://mp.weixin.qq.com/s/fq7U_x4LftlqFx3vD1S3jw"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5C0F\u7EA2\u4E66\u591A\u573A\u666F\u5E94\u7528",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5C0F\u7EA2\u4E66\u7684\u5B9E\u8DF5\u6848\u4F8B\u5206\u4EAB",
                href: "https://mp.weixin.qq.com/s/67fxOqXbwFO9go7K_7x-CA"
            }, 
        ]
    },
    {
        name: "\u80E1\u76FC\u76FC",
        company: "\u5FAE\u4F17\u94F6\u884C",
        title: "\u6570\u636E\u5E93\u5E73\u53F0\u5BA4\u7ECF\u7406",
        links: [
            {
                name: "\u5FAE\u4F17\u94F6\u884C\u6570\u636E\u5E93\u67B6\u6784\u6F14\u8FDB\u53CA TiDB \u5B9E\u8DF5\u7ECF\u9A8C",
                href: "https://pingcap.com/cases-cn/user-case-webank/"
            },
            {
                name: "\u3010Talk\u3011\u5FAE\u4F17\u94F6\u884C TiDB \u5B9E\u8DF5",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011\u5FAE\u4F17\u94F6\u884C\u6838\u5FC3\u6570\u636E\u5E93\u67B6\u6784\u6F14\u8FDB",
                href: "https://archsummit.infoq.cn/2019/shenzhen/presentation/1828"
            }, 
        ]
    },
    {
        name: "\u5218\u6625\u96F7",
        company: "58 \u96C6\u56E2",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "TiDB \u5728 58 \u96C6\u56E2\u7684\u5E94\u7528\u4E0E\u5B9E\u8DF5",
                href: "https://pingcap.com/cases-cn/user-case-58/"
            },
            {
                name: "TiDB \u62D3\u6251\u67E5\u8BE2\u5DE5\u5177 qtidb",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-qtidb/908"
            },
            {
                name: "TiDB\u76D1\u63A7\u5B9E\u73B0--\u5B58\u6D3B\u76D1\u63A7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/918"
            },
            {
                name: "\u8BB0\u4E00\u6B21 TiDB \u4E1A\u52A1\u4F18\u5316",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1781/2"
            },
            {
                name: "\u518D\u8BB0\u4E00\u6B21\u4E1A\u52A1\u4F18\u5316",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1818"
            }, 
        ]
    },
    {
        name: "\u7F57\u745E\u661F",
        company: "\u767E\u80DC\u4E2D\u56FD",
        title: "\u5927\u6570\u636E\u7ECF\u7406",
        links: [
            {
                name: "\u6613\u679C TiDB \u7684\u4F7F\u7528\u4EE5\u53CA\u6570\u636E\u4E2D\u53F0\u7684\u601D\u8003",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/913"
            },
            {
                name: "\u3010Talk\u3011\u6613\u679C\u96C6\u56E2\u6570\u636E\u4E2D\u53F0\u7684\u8F6C\u578B\u548C\u5B9E\u8DF5",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011\u6613\u679C\u96C6\u56E2\u7684\u6570\u636E\u5E73\u53F0\u5EFA\u8BBE\u5386\u7A0B",
                href: "https://mp.weixin.qq.com/s/eDuJUQBMoO0jx9CpHYbxEg"
            }, 
        ]
    },
    {
        name: "\u9EC4\u851A",
        company: "\u5FAE\u4F17\u94F6\u884C",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "\u5FAE\u4F17\u94F6\u884C\u6570\u636E\u5E93\u67B6\u6784\u6F14\u8FDB\u53CA TiDB \u5B9E\u8DF5\u7ECF\u9A8C",
                href: "https://pingcap.com/cases-cn/user-case-webank/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5FAE\u4F17\u94F6\u884C\u7684\u5B9E\u8DF5\u4E0E\u5E94\u7528",
                href: "https://pingcap.com/community-cn/devcon2019/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5FAE\u4F17\u94F6\u884C\u7684\u5B9E\u8DF5\u4E4B\u65C5",
                href: "https://pingcap.com/community-cn/devcon2019/"
            },
            {
                name: "\u3010Talk\u3011TiDB on ARM",
                href: "https://mp.weixin.qq.com/s/FU04PacLlmNH89ETusN69A"
            }, 
        ]
    },
    {
        name: "\u9EC4\u9F99",
        company: "360 \u91D1\u878D",
        title: "\u6DF1\u5733\u5927\u6570\u636E\u7EC4\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u5B9E\u65F6\u6E20\u9053\u8F6C\u5316\u5206\u6790\u7684\u5E94\u7528",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1060"
            },
            {
                name: "\u3010Talk\u3011TiDB \u6570\u4ED3\u5728 360 \u91D1\u878D\u6E20\u9053\u8FD0\u8425\u7684\u5E94\u7528",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u5B9E\u65F6\u6E20\u9053\u8F6C\u5316\u5206\u6790\u7684\u5E94\u7528",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug/881"
            }, 
        ]
    },
    {
        name: "\u5B59\u7384",
        company: "\u5948\u5B66\u6559\u80B2",
        title: "\u521B\u59CB\u4EBA & CEO",
        links: [
            {
                name: "\u8F6C\u8F6C\u6570\u636E\u5E93\u67B6\u6784\u6784\u5EFA\u4E4B\u9053",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1021"
            },
            {
                name: "\u3010Talk\u3011All in\uFF01\u8F6C\u8F6C TiDB \u5927\u89C4\u6A21\u5B9E\u8DF5\u4E4B\u65C5",
                href: "https://pingcap.com/community-cn/devcon2019/"
            },
            {
                name: "\u3010Talk\u3011\u8F6C\u8F6C\u6570\u636E\u5E93\u67B6\u6784\u6784\u5EFA\u4E4B\u9053",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-tidb/865"
            }, 
        ]
    },
    {
        name: "\u90ED\u78CA\u6D9B",
        company: "\u7231\u5947\u827A",
        title: "\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u7231\u5947\u827A\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1396/1"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u7231\u5947\u827A\u7684\u5E94\u7528\u5B9E\u8DF5",
                href: "https://pingcap.com/community-cn/techday2019/"
            },
            {
                name: "\u3010Talk\u3011\u7231\u5947\u827A\u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug/1043"
            }, 
        ]
    },
    {
        name: "\u674E\u632F\u73AF",
        company: "\u8D1D\u58F3\u91D1\u670D",
        title: "\u8D44\u6DF1\u5927\u6570\u636E\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u8D1D\u58F3\u91D1\u670D TiDB \u5728\u7EBF\u8DE8\u673A\u623F\u8FC1\u79FB\u5B9E\u8DF5",
                href: "https://pingcap.com/cases-cn/user-case-beikejinfu/"
            },
            {
                name: "\u3010Talk\u3011\u8D1D\u58F3\u91D1\u670D\u57FA\u4E8E TiDB \u7684\u6570\u636E\u4E2D\u53F0\u6F14\u8FDB",
                href: "https://pingcap.com/community-cn/techday2019/"
            }, 
        ]
    },
    {
        name: "\u8D3E\u4E16\u95FB",
        company: "\u4EAC\u4E1C\u4E91",
        title: "\u67B6\u6784\u5E08",
        links: [
            {
                name: "TiKV \u5F00\u53D1\u73AF\u5883\u5355\u673A\u90E8\u7F72",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tikv/452"
            },
            {
                name: "\u6280\u672F\u9009\u578B\u4E2D\u7684\u975E\u6280\u672F\u56E0\u7D20",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1358"
            },
            {
                name: "DRDS vs TiDB",
                href: "https://blog.csdn.net/jiashiwen/article/details/89177068"
            }, 
        ]
    },
    {
        name: "\u674E\u6587\u6770",
        company: "\u7F51\u6613\u4E92\u5A31",
        title: "\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB \u5728\u7F51\u6613\u4E92\u5A31\u7684\u9009\u62E9\u4E0E\u4F53\u9A8C",
                href: "https://pingcap.com/cases-cn/user-case-wangyihuyu/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u7F51\u6613\u4E92\u5A31\u7684\u9009\u62E9\u4E0E\u4F53\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug/1227"
            },
            {
                name: "\u3010Talk\u3011\u7F51\u6613\u4E92\u5A31\u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-x-shopee/1550"
            }, 
        ]
    },
    {
        name: "\u5218\u6625\u8F89",
        company: "Shopee",
        title: "DBA Manager",
        links: [
            {
                name: "TiDB 3.0\uFF1A\u7A97\u53E3\u51FD\u6570\u521D\u4F53\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-3-0/348"
            },
            {
                name: "TiDB \u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://mp.weixin.qq.com/s/m6jD0oB0sIHpH1z2gc3pew"
            },
            {
                name: "\u3010Talk\u3011TiDB \u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-x-shopee/1550"
            }, 
        ]
    },
    {
        name: "\u4EE3\u6653\u78CA",
        company: "360 \u667A\u6167\u5546\u4E1A",
        title: "\u6570\u636E\u5E93\u8FD0\u7EF4\u4E13\u5BB6",
        links: [
            {
                name: "360 \u5546\u4E1A\u5316 TiDB \u5199\u70ED\u70B9\u7684\u4F18\u5316\u601D\u8DEF",
                href: "https://mp.weixin.qq.com/s/E6GotdOAVPKlWdKIrW1SQA"
            },
            {
                name: "\u3010Talk\u3011TiDB\u5728360\u5546\u4E1A\u5316\u4E1A\u52A1\u7684\u5E94\u7528\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-tidb/1500"
            }, 
        ]
    },
    {
        name: "\u738B\u5FD7\u5E7F",
        company: "\u5E73\u5B89\u79D1\u6280",
        title: "\u8D44\u6DF1\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB \u79C1\u6709\u4E91\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1059"
            },
            {
                name: "TiDB \u6162\u65E5\u5FD7\u89E3\u6790\u6E90\u7801\u89E3\u8BFB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1902"
            },
            {
                name: "\u3010Talk\u3011TiDB \u79C1\u6709\u4E91\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-tidb-cloud/1041"
            }, 
        ]
    },
    {
        name: "\u6768\u6587",
        company: "\u65E9\u5B89\u79D1\u6280",
        title: "\u540E\u7AEF\u6280\u672F\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u5728 GCP \u4E0A\u4F7F\u7528 TiDB Operator \u6784\u5EFA TiDB \u96C6\u7FA4",
                href: "https://pingkai.cn/tidbcommunity/forum/t/gcp-tidb-operator-tidb/437"
            },
            {
                name: "\u5728 minikube \u4E0A\u4F7F\u7528 TiDB Operator \u6784\u5EFA TiDB \u96C6\u7FA4",
                href: "https://pingkai.cn/tidbcommunity/forum/t/minikube-tidb-operator-tidb/1382"
            },
            {
                name: "\u5E73\u51EF\u661F\u8FB0 Talent Plan\uFF08\u5E7F\u5DDE\uFF09\u7B2C\u56DB\u671F\u516C\u5F00\u8BFE\u7B14\u8BB0",
                href: "https://pingkai.cn/tidbcommunity/forum/t/pingcap-talent-plan/1397"
            },
            {
                name: "TiDB \u4E2D\u7684\u5168\u5C40\u552F\u4E00 ID",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-id/1521"
            }, 
        ]
    },
    {
        name: "\u5F20\u96EF",
        company: "bilibili",
        title: "DBA",
        links: [
            {
                name: "TiDB \u8FFD\u756A\u624B\u5E10\uFF08\u4E0A\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1637"
            },
            {
                name: "TiDB \u8FFD\u756A\u624B\u5E10\uFF08\u4E2D\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1772"
            },
            {
                name: "TiDB \u8FFD\u756A\u624B\u5E10\uFF08\u4E0B\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb/1773"
            },
            {
                name: "TiDB \u8FFD\u756A\u624B\u8D26\uFF08\u756A\u5916\uFF09TiDB Server \u5185\u6838\u539F\u7406\u5B66\u4E60\u7B14\u8BB0",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-tidb-server/2033"
            }, 
        ]
    },
    {
        name: "\u4FAF\u5723\u6587",
        company: "\u8D1D\u58F3\u627E\u623F",
        title: "\u6280\u672F\u603B\u76D1",
        links: [
            {
                name: "TiDB \u5B9E\u6218\u4F18\u5316\u4E4B SQL \u5E38\u89C1\u95EE\u9898\u4E0E\u4F18\u5316\u6848\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33657"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5B9E\u6218\u4F18\u5316\u4E4B SQL \u5E38\u89C1\u95EE\u9898\u4E0E\u4F18\u5316\u6848\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-tidb/1500"
            },
            {
                name: "\u3010Talk\u3011Oracle&TiDB \u9AD8\u53EF\u7528\u6280\u672F\u6700\u4F73\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/2201"
            }, 
        ]
    },
    {
        name: "\u706B\u70E7",
        company: "\u5C0F\u7535\u79D1\u6280",
        title: "\u9996\u5E2D\u67B6\u6784\u5E08",
        links: [
            {
                name: "TiDB \u5728\u67D0\u9910\u996E SaaS \u670D\u52A1\u5546\u7684\u5B9E\u8DF5\u53CA\u6D77\u5916\u673A\u623F\u6784\u5EFA",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33030"
            },
            {
                name: "\u3010Talk\u3011 TiDB \u5728\u4E8C\u7EF4\u706B\u7684\u5B9E\u8DF5\u53CA\u6D77\u5916\u673A\u623F\u6784\u5EFA",
                href: "https://pingcap.com/community-cn/techday2019/"
            }, 
        ]
    },
    {
        name: "\u5E38\u5F66\u5FB7",
        company: "UCloud",
        title: "\u5B58\u50A8\u7EC4\u4EF6\u4EA7\u54C1\u90E8\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728 UCloud \u516C\u6709\u4E91\u4E0A\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-ucloud/1115"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728 UCloud \u516C\u6709\u4E91\u4E0A\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug-tidb-cloud/1041"
            },
            {
                name: "\u3010Talk\u3011TiDB Service \u9AD8\u53EF\u7528\u67B6\u6784",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/2201"
            }, 
        ]
    },
    {
        name: "\u9AD8\u6D77\u6D9B",
        company: "\u7F8E\u56E2\u70B9\u8BC4",
        title: "RD",
        links: [
            {
                name: "TiDB \u4E4B DDL \u5B66\u4E60\u603B\u7ED3",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-ddl/2036"
            },
            {
                name: "\u4F7F pt-kil l\u548C pt-query-digest \u5DE5\u5177\u517C\u5BB9 TiDB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/pt-kill-pt-query-digest-tidb/2022"
            },
            {
                name: "PD \u7684\u65F6\u949F\u670D\u52A1\u2014\u2014 TSO",
                href: "https://pingkai.cn/tidbcommunity/forum/t/pd-tso/2026"
            },
            {
                name: "DM \u5728 Docker \u73AF\u5883\u90E8\u7F72\u5B89\u88C5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/dm-docker/2027"
            }, 
        ]
    },
    {
        name: "\u5415\u78CA",
        company: "\u7F8E\u56E2\u70B9\u8BC4",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "TiDB \u5728\u6469\u62DC\u5355\u8F66\u7684\u6DF1\u5EA6\u5B9E\u8DF5\u53CA\u5E94\u7528",
                href: "https://pingcap.com/cases-cn/user-case-mobike-2/"
            },
            {
                name: "TiDB MVCC \u591A\u7248\u672C\u4FDD\u5B58\u673A\u5236\u53CA\u5176\u5BF9\u6027\u80FD\u7684\u5F71\u54CD",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-mvcc/1350"
            },
            {
                name: "\u76F4\u51FB\u5907\u4EFD\u75DB\u70B9\uFF1A\u57FA\u4E8E TiDB Binlog \u7684\u5FEB\u901F\u65F6\u95F4\u70B9\u6062\u590D",
                href: "https://mp.weixin.qq.com/s/EmHPOVnYXTl0xy069OEcRw"
            }, 
        ]
    },
    {
        name: "\u8BB8\u8D85",
        company: "VIPKID",
        title: "\u8D44\u6DF1 DBA \u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "VIPKID \u7684\u9AD8\u53EF\u7528\u67B6\u6784\u8BBE\u8BA1\u4E0E\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33656"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728 VIPKID \u7684\u5C55\u671B",
                href: "https://pingcap.com/community-cn/devcon2019/"
            },
            {
                name: "\u3010Talk\u3011VIPKID \u7684\u9AD8\u53EF\u7528\u67B6\u6784\u8BBE\u8BA1\u4E0E\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/2201"
            }, 
        ]
    },
    {
        name: "\u5218\u5149\u4EAE",
        company: "\u4E30\u5DE2\u79D1\u6280",
        title: "\u4E2D\u95F4\u4EF6\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB new feature max_execution_time",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tidb-new-feature-max-execution-time/309"
            },
            {
                name: "TiDB \u5728\u4E30\u5DE2\u6838\u5FC3\u652F\u4ED8\u5E73\u53F0\u767E\u4EBF\u7EA7\u6570\u636E\u7684\u6DF1\u5EA6\u5B9E\u8DF5",
                href: "https://mp.weixin.qq.com/s/eVgKrHZBsppE02SMXbbJ4Q"
            },
            {
                name: "\u3010Talk\u3011\u4E30\u5DE2\u652F\u4ED8\u5E73\u53F0\u8FC1\u79FB\u4E4B\u65C5",
                href: "https://mp.weixin.qq.com/s/GigCkrY0gCcgSD_Vn1gRoA"
            }, 
        ]
    },
    {
        name: "\u65CB\u51EF",
        company: "58 \u96C6\u56E2",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "58 \u96C6\u56E2\u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/1784"
            },
            {
                name: "Elastic Stack\u5904\u7406TiDB\u6162\u65E5\u5FD7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/elastic-stack-tidb/2051"
            },
            {
                name: "\u3010Talk\u301158 \u96C6\u56E2\u7684\u6570\u636E\u5E93\u6280\u672F\u9009\u578B\u601D\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/tug/1043"
            }, 
        ]
    },
    {
        name: "\u5085\u5C11\u5CF0",
        company: "\u65B0\u4E1C\u65B9",
        title: "\u6570\u636E\u670D\u52A1\u56E2\u961F\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u65B0\u4E1C\u65B9\u4E1A\u52A1\u524D\u53F0\u53CA\u4E2D\u53F0\u7684\u843D\u5730",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/2766"
            },
            {
                name: "\u3010Talk\u3011\u65B0\u4E1C\u65B9\u65B0\u4E00\u4EE3\u62A5\u540D\u7CFB\u7EDF\u6570\u636E\u5E93\u9009\u578B",
                href: "https://pingcap.com/community-cn/devcon2019/"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u65B0\u4E1C\u65B9\u4E1A\u52A1\u524D\u53F0\u53CA\u4E2D\u53F0\u7684\u843D\u5730",
                href: "https://pingcap.com/community-cn/techday2019/"
            }, 
        ]
    }, 
];
/* harmony default export */ var mva2019 = (data);

;// CONCATENATED MODULE: ./src/pages/tug/mva/data/mva2020.js
var mva2020_data = [
    {
        name: "\u674E\u94F6\u9F99",
        company: "\u9A6C\u4E0A\u6D88\u8D39\u91D1\u878D",
        title: "\u5BB9\u5668\u4E91\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u9A6C\u4E0A\u6D88\u8D39\u91D1\u878D\u6838\u5FC3\u8D26\u52A1\u7CFB\u7EDF\u5F52\u6863\u53CA\u8DD1\u6279\u4E1A\u52A1\u4E0B\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/2686"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728\u9A6C\u4E0A\u6D88\u8D39\u91D1\u878D\u603B\u8D26\u7CFB\u7EDF\u7684\u5BB9\u5668\u5316\u5B9E\u8DF5\u4E4B\u8DEF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35399"
            }, 
        ]
    },
    {
        name: "\u8D3A\u78CA",
        company: "360",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "TiDB \u5728 360 \u4E91\u5E73\u53F0\u7684\u843D\u5730\u548C\u5B9E\u8DF5\u7ECF\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/32849"
            },
            {
                name: "\u4E00\u7BC7\u6587\u7AE0\u5E26\u4F60\u73A9\u8F6C TiDB \u707E\u96BE\u6062\u590D",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/34246"
            },
            {
                name: "TiDB \u5927\u89C4\u6A21\u8282\u70B9\u4E0B\u7EBF\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37485"
            },
            {
                name: "DM \u8FD0\u7EF4\u8E29\u5751\u5B9E\u8DF5\u603B\u7ED3",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/63512"
            }, 
        ]
    },
    {
        name: "\u7530\u5E05\u840C",
        company: "\u4EAC\u4E1C\u6570\u79D1",
        title: "DBA",
        links: [
            {
                name: "TiDB \u7528\u4EC0\u4E48\u4FDD\u8BC1\u5907\u4EFD\u7684\u4E00\u81F4\u6027",
                href: "https://mp.weixin.qq.com/s/XVhDWap-QN5GLPt-1edvOg"
            },
            {
                name: "\u6D45\u6790 TiDB \u4E8C\u9636\u6BB5\u63D0\u4EA4",
                href: "https://mp.weixin.qq.com/s/Cmw4Dl8vt7-wV9XlzzvURA"
            },
            {
                name: "\u521D\u63A2 TiDB-TiFlash",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33523"
            }, 
        ]
    },
    {
        name: "\u9773\u732E\u65D7",
        company: "\u6C7D\u8F66\u4E4B\u5BB6",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "\u4E00\u6B21\u89E3\u51B3\u8BFB\u5199\u51B2\u7A81\u7684\u6848\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33205/4"
            },
            {
                name: "TiDB \u5206\u533A\u8868\u4F18\u5316\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33810"
            },
            {
                name: "TiDB \u5728\u6C7D\u8F66\u4E4B\u5BB6 818 \u53F0\u7F51\u4E92\u52A8\u9879\u76EE\u4E2D\u7684\u5E94\u7528",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37016"
            }, 
        ]
    },
    {
        name: "\u674E\u632F\u73AF",
        company: "\u8D1D\u58F3\u91D1\u670D",
        title: "\u5927\u6570\u636E\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB in Action-TiSpark \u5EFA\u6784\u4E0E\u539F\u7406",
                href: ""
            },
            {
                name: "\u3010Talk\u3011TiDB \u5B9E\u65F6\u6570\u636E\u5904\u7406\u5E73\u53F0\u5B9E\u6218",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u5B59\u6653\u5149",
        company: "\u77E5\u4E4E",
        title: "\u6280\u672F\u5E73\u53F0\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u5355\u96C6\u7FA4\u4E24\u6570\u636E\u4E2D\u5FC3 TiDB \u707E\u5907\u65B9\u6848",
                href: "https://zhuanlan.zhihu.com/p/138044746?utm_source=wechat_session&utm_medium=social&s_s_i=I9a9xbgJ7ZjNA5NAM6a6yWIUW7%2Fr6AL21w2IKcyv45I%3D&s_r=1&from=timeline&isappinstalled=0&wechatShare=1"
            }, 
        ]
    },
    {
        name: "\u7F57\u745E\u661F",
        company: "\u767E\u80DC\u4E2D\u56FD",
        title: "\u5927\u6570\u636E\u7ECF\u7406",
        links: [
            {
                name: "TiDB in Action-TiSpark \u5EFA\u6784\u4E0E\u539F\u7406",
                href: ""
            },
            {
                name: "TiDB in Action-\u7528 TiUP \u90E8\u7F72\u672C\u5730\u6D4B\u8BD5\u73AF\u5883",
                href: "https://book.tidb.io/session2/chapter1/tiup-playground.html#112-%E7%94%A8-tiup-%E9%83%A8%E7%BD%B2%E6%9C%AC%E5%9C%B0%E6%B5%8B%E8%AF%95%E7%8E%AF%E5%A2%83"
            }, 
        ]
    },
    {
        name: "\u5218\u6625\u96F7",
        company: "58 \u96C6\u56E2",
        title: "DBA",
        links: [
            {
                name: "58 \u540C\u57CE TiDB4.0 \u62A5\u544A",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36377"
            },
            {
                name: "58 \u540C\u57CE\u5927\u89C4\u6A21 TiDB \u8FD0\u7EF4\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/62990"
            },
            {
                name: "TiFlash \u8FD0\u7EF4\u6F2B\u8C08\u8C08",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/63052"
            },
            {
                name: "\u6F2B\u8C08 TiDB \u6570\u636E\u5E93\u90E8\u7F72",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/63462"
            }, 
        ]
    },
    {
        name: "\u80E1\u76FC\u76FC",
        company: "\u5FAE\u4F17\u94F6\u884C",
        title: "\u6570\u636E\u5E93\u5E73\u53F0\u7ECF\u7406",
        links: [
            {
                name: "TiDB in Action-TiDB \u5E38\u89C1\u914D\u7F6E\u4F18\u5316",
                href: ""
            },
            {
                name: "TiDB in Action-TiKV \u7EBF\u7A0B\u6C60\u4F18\u5316",
                href: "https://book.tidb.io/session4/chapter8/threadpool-optimize.html#821-tikv-%E7%BA%BF%E7%A8%8B%E6%B1%A0%E4%BC%98%E5%8C%96"
            },
            {
                name: "TiDB \u5728\u5FAE\u4F17\u94F6\u884C\u6838\u5FC3\u573A\u666F\u6F14\u8FDB\u8DEF\u5F84\u53CA\u65B9\u5411\u63A2\u7D22",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u80E1\u56FD\u9752",
        company: "\u6570\u636E\u5E93\u4ECE\u4E1A\u8005",
        title: "",
        links: [
            {
                name: "TiDB in Action-MongoDB \u5230 TiDB",
                href: "https://book.tidb.io/session4/chapter5/from-mongodb-to-tidb.html#57-mongodb-%E8%BF%81%E7%A7%BB%E5%88%B0-tidb"
            },
            {
                name: "\u3010Talk\u3011\u6570\u636E\u5E93\u9009\u578B\u4E4B MongoDB \u7684\u6700\u4F73\u573A\u666F\u548C\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/34471"
            }, 
        ]
    },
    {
        name: "\u5F20\u96EF",
        company: "bilibili",
        title: "DBA",
        links: [
            {
                name: "TiDB in Action-RBAC",
                href: ""
            },
            {
                name: "DM \u540C\u6B65\u5355\u673A MySQL \u5230 TiDB",
                href: "https://book.tidb.io/session4/chapter5/from-single-mysql-to-tidb.html#511-dm-%E5%90%8C%E6%AD%A5%E5%8D%95%E6%9C%BA-mysql-%E5%88%B0-tidb-%E7%9A%84%E5%AE%9E%E8%B7%B5"
            },
            {
                name: "\u3010Talk\u3011TiDB \u5728 bilibili \u7684\u5B9E\u8DF5 2.0",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u5F90\u5609\u57E5",
        company: "\u5EFA\u4FE1\u91D1\u79D1",
        title: "DBA",
        links: [
            {
                name: " TiDB in Action-TiFlash \u67B6\u6784\u4E0E\u539F\u7406",
                href: "https://book.tidb.io/session1/chapter9/tiflash-architecture.html#92-tiflash-%E6%9E%B6%E6%9E%84%E4%B8%8E%E5%8E%9F%E7%90%86"
            },
            {
                name: "\u6D77\u5916\u76F4\u64AD\u884C\u4E1A\u7684 TiDB 4.0 \u7EBF\u4E0A\u4F53\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u76AE\u96EA\u950B",
        company: "\u4E91\u96C6",
        title: "\u7814\u53D1\u7ECF\u7406",
        links: [
            {
                name: "\u4E91\u96C6\u8D22\u52A1\u4E1A\u52A1TiDB\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35287"
            }, 
        ]
    },
    {
        name: "\u5218\u6C5F",
        company: "\u4F34\u9C7C",
        title: "DBA",
        links: [
            {
                name: "\u4F34\u9C7C\u6570\u636E\u5E93\u4E4B\u6162\u65E5\u5FD7\u7CFB\u7EDF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36185"
            },
            {
                name: "\u4F34\u9C7C TiDB \u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35639"
            },
            {
                name: "\u4F34\u9C7C\u6570\u636E\u5E93\u4E4B\u6027\u80FD\u5927\u76D8",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37337"
            },
            {
                name: "\u4F34\u9C7C\u6570\u636E\u5E93\u4E4BMongoDB\u6570\u636E\u5728\u7EBF\u8FC1\u79FB\u5230TiDB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/66838"
            }, 
        ]
    },
    {
        name: "\u6731\u535A\u5E05",
        company: "\u963F\u91CC\u4E91",
        title: "\u6570\u636E\u5E93\u6280\u672F\u670D\u52A1\u4E13\u5BB6",
        links: [
            {
                name: "\u3010Talk\u3011TiDB \u5728\u9AD8\u901F\u589E\u957F\u89C6\u9891\u4E1A\u52A1\u4E2D\u7684\u5E94\u7528",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            },
            {
                name: "\u3010Talk\u3011TiDB\u4E0A\u4E91\u5B9E\u8DF5\u5206\u4EAB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36583"
            }, 
        ]
    },
    {
        name: "\u4EE3\u6653\u78CA",
        company: "360",
        title: "\u6570\u636E\u5E93\u8FD0\u7EF4\u4E13\u5BB6",
        links: [
            {
                name: "tiup \u76EE\u5F55\u51B2\u7A81\u68C0\u6D4B\u4E0D\u5065\u5168\u5BFC\u81F4\u7684\u8282\u70B9\u88AB destroy \u95EE\u9898\u4EE5\u53CA\u89E3\u51B3",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35422"
            },
            {
                name: "TiUP\u5347\u7EA7TiFlash\u91CD\u542F\u5931\u8D25\u89E3\u51B3\u65B9\u6848",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/34926"
            },
            {
                name: "\u89E3\u51B3\u65B9\u6848\u4E4B\uFF1ADM relay \u5904\u7406\u5355\u5143\u62A5\u9519...",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35063"
            },
            {
                name: "TiDB \u7EDF\u8BA1\u4FE1\u606F\u539F\u7406\u7B80\u4ECB\u4E0E\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37691"
            }, 
        ]
    },
    {
        name: "\u8D75\u6D77\u519B",
        company: "\u7406\u60F3\u6C7D\u8F66",
        title: "\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB 4.0 \u8BD5\u73A9\u4F53\u9A8C\uFF1ATiDB\u6027\u80FD\u5BF9\u6BD4\uFF08v3.0.12 VS v4.0.0-rc\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33519"
            },
            {
                name: "TiDB \u70ED\u70B9\u95EE\u9898\u5B9A\u4F4D",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36395"
            },
            {
                name: "DM v1 \u5347\u7EA7 v2 \u521D\u4F53\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37053"
            },
            {
                name: "SQL \u4E0A\u7EBF\u5F15\u53D1\u7684\u8840\u6848",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37239"
            }, 
        ]
    },
    {
        name: "\u9EC4\u6F47",
        company: "\u7F8E\u56E2",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "\u3010Talk\u3011\u6570\u636E\u5E93\u53D1\u5C55\u8D8B\u52BF\uFF0C\u878D\u5408\u8FD8\u662F\u7EC6\u5206?",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37180"
            },
            {
                name: "\u3010Talk\u3011TiDB\u4E0A\u4E91\u5B9E\u8DF5\u5206\u4EAB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36583"
            },
            {
                name: "\u3010Talk\u3011TiDB \u7684\u5E38\u89C1\u67B6\u6784\u5E94\u7528\u573A\u666F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67754"
            }, 
        ]
    },
    {
        name: "\u4E8E\u632F\u534E",
        company: "\u5317\u94F6\u91D1\u79D1",
        title: "\u4E91\u8BA1\u7B97\u5E94\u7528\u90E8\u526F\u603B\u7ECF\u7406",
        links: [
            {
                name: "TiDB \u5728\u91D1\u878D\u573A\u666F\u91CC\u90A3\u4E9B\u4E0D\u5F97\u4E0D\u8BF4\u7684\u4E8B",
                href: "https://mp.weixin.qq.com/s/GUZK-ccs7CK6zBYdZa5uGQ"
            },
            {
                name: "\u3010Talk\u3011\u5982\u4F55\u8BC4\u5224\u4E00\u4E2A\u6570\u636E\u67B6\u6784\u7684\u597D\u574F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/36709"
            }, 
        ]
    },
    {
        name: "\u8BB8\u8D85",
        company: "VIPKID",
        title: "\u8D44\u6DF1\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiUP \u4F7F\u7528\u68B3\u7406",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/33540"
            },
            {
                name: "TiDB 4.0 \u5728 VIPKID \u7684\u5E94\u7528\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397/1"
            }, 
        ]
    },
    {
        name: "\u5E38\u5F66\u5FB7",
        company: "UCloud",
        title: "\u5B58\u50A8\u7EC4\u4EF6\u4EA7\u54C1\u90E8\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u3010Talk\u3011UCloud TiDB \u516C\u6709\u4E91\u670D\u52A1\u63A2\u7D22",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u6C6A\u6D89\u6D0B",
        company: "\u8F66\u597D\u591A",
        title: "\u5927\u6570\u636E\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u5728\u8F66\u597D\u591A\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/63576"
            },
            {
                name: "\u3010Talk\u3011\u6570\u636E\u5E93\u53D1\u5C55\u8D8B\u52BF\uFF0C\u878D\u5408\u8FD8\u662F\u7EC6\u5206?",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37180"
            }, 
        ]
    },
    {
        name: "\u674E\u6587\u6770",
        company: "\u7F51\u6613\u4E92\u5A31",
        title: "\u6570\u636E\u7814\u53D1\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u7F51\u6613\u4E92\u5A31\u7684\u6570\u636E\u5E93\u9009\u578B\u548C TiDB \u5E94\u7528\u5B9E\u8DF5",
                href: "https://mp.weixin.qq.com/s/1u79vN9by1xGeJDkWiSUew"
            },
            {
                name: "\u3010Talk\u3011\u6570\u636E\u5E93\u53D1\u5C55\u8D8B\u52BF\uFF0C\u878D\u5408\u8FD8\u662F\u7EC6\u5206?",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37180"
            }, 
        ]
    },
    {
        name: "\u8D3E\u4E16\u95FB",
        company: "\u4EAC\u4E1C\u4E91",
        title: "\u67B6\u6784\u5E08",
        links: [
            {
                name: "\u793E\u533A\u8D44\u6E90\u8FD9\u4E48\u4E30\u5BCC\u6211\u4EEC\u600E\u4E48\u6284\u4F5C\u4E1A",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/37425"
            }, 
        ]
    },
    {
        name: "\u7F8A\u6B22",
        company: "OPPO",
        title: "\u9AD8\u7EA7\u8FD0\u7EF4\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB in Action-TiFlashTiSpark \u7ED3\u5408\u5927\u6570\u636E\u4F53\u7CFB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/64050"
            },
            {
                name: "\u3010Talk\u3011TiDB \u548C\u5927\u6570\u636E\u6DF7\u8BBF\u5728 OPPO \u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/64050"
            }, 
        ]
    },
    {
        name: "\u80E1\u7136",
        company: "\u9F99\u6E56\u5730\u4EA7",
        title: "DBA \u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u5730\u4EA7TiDB\u4F7F\u7528\u521D\u63A2\u7D22",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/63899"
            },
            {
                name: "TiDB DM\u6269\u5BB9\u548C\u76D1\u63A7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67685"
            }, 
        ]
    },
    {
        name: "\u5180\u6D69\u4E1C",
        company: "\u8F6C\u8F6C",
        title: "\u6570\u636E\u5E93\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB-In-Action - TiKV is Busy \u5904\u7406\u601D\u8DEF",
                href: "https://book.tidb.io/session4/chapter7/tikv-is-busy.html#73-tikv-is-busy-%E5%A4%84%E7%90%86%E6%80%9D%E8%B7%AF"
            },
            {
                name: "\u3010Talk\u3011TiDB 4.0 \u65B0\u7279\u6027\u5728\u7535\u5546\u884C\u4E1A\u7684\u63A2\u7D22",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35397"
            }, 
        ]
    },
    {
        name: "\u5F20\u4EBF\u7693",
        company: "\u5C0F\u7EA2\u4E66",
        title: "\u5927\u6570\u636E\u7814\u53D1\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u5C0F\u7EA2\u4E66\u6570\u636E\u67B6\u6784\u53CA TiDB \u4F7F\u7528\u573A\u666F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/35820"
            },
            {
                name: "\u3010Talk\u3011\u5C0F\u7EA2\u4E66\u7684\u5927\u6570\u636E\u65B0\u5B9E\u8DF5",
                href: "https://www.bilibili.com/video/BV1Lt4y1C7AH"
            }, 
        ]
    },
    {
        name: "\u95EB\u6653\u5B87",
        company: "\u5F97\u7269",
        title: "\u6570\u636E\u5E93\u56E2\u961F\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "\u3010\u5706\u684C\u8BA8\u8BBA\u3011\u6570\u5B57\u5316\u8F6C\u578B\u4E0B\u7684\u65B0\u6570\u636E\u67B6\u6784\u9009\u578B",
                href: "#"
            }, 
        ]
    }, 
];
/* harmony default export */ var mva2020 = (mva2020_data);

;// CONCATENATED MODULE: ./src/pages/tug/mva/data/mva2021.js
var mva2021_data = [
    {
        name: "\u6C88\u65F8",
        company: "\u795E\u5DDE\u6570\u7801",
        title: "CIO",
        links: [
            {
                name: "TiDB for PostgreSQL\u2014\u725B\u5200\u5C0F\u8BD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93433"
            },
            {
                name: "TiDB 5.0 \u5F02\u6B65\u4E8B\u52A1\u7279\u6027\u4F53\u9A8C\u2014\u2014\u57FA\u4E8EX86\u548CARM\u6DF7\u5408\u90E8\u7F72\u67B6\u6784",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93002"
            },
            {
                name: "TiDB Parser \u6A21\u5757\u7684\u7B80\u5355\u89E3\u8BFB\u4E0E\u6539\u9020\u65B9\u6CD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93317"
            },
            {
                name: "\u4EE5TiDB\u70ED\u70B9\u95EE\u9898\u6765\u8C08Region\u7684\u8C03\u5EA6\u6D41\u7A0B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69850"
            }, 
        ]
    },
    {
        name: "\u5218\u6625\u96F7",
        company: "58 \u540C\u57CE",
        title: "DBA",
        links: [
            {
                name: "TiDB 5.0 \u5347\u7EA7\u6027\u80FD\u521D\u4F53\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69855"
            },
            {
                name: "TiFlash 5.x \u4E0E 4.x \u5BF9\u6BD4\u6D4B\u8BD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69933"
            },
            {
                name: "\u67D0\u62A5\u8868\u4E1A\u52A1\u5347\u7EA7 5.0 \u89E3\u51B3\u6162SQL\u95EE\u9898",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/92876"
            }, 
        ]
    },
    {
        name: "\u4EE3\u6653\u78CA",
        company: "360",
        title: "\u6570\u636E\u5E93\u8FD0\u7EF4\u4E13\u5BB6",
        links: [
            {
                name: "TiCDC \u4F7F\u7528\u5FC3\u5F97",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69259"
            },
            {
                name: "TiCDC \u5E94\u7528\u573A\u666F\u89E3\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/152954"
            },
            {
                name: "\u5173\u4E8E TiDB \u6027\u80FD\u4F18\u5316\u7684\u4E00\u4E9B\u601D\u8003",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153160"
            },
            {
                name: "\u5199\u51B2\u7A81\u573A\u666F\u4E0B\u7684\u60B2\u89C2/\u4E50\u89C2\u4E8B\u52A1\u6A21\u578B\u9009\u62E9",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93470"
            },
            {
                name: "\u8BB0\u4E00\u573A DM \u540C\u6B65\u5F15\u53D1\u7684 Auto_Increment \u4E3B\u952E\u51B2\u7A81\u6F2B\u8C08",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68427"
            },
            {
                name: "\u8BB0\u4E00\u6B21 Lightning \u5BFC\u5165\u5931\u8D25\u5BFC\u81F4\u7684 TiDB \u96C6\u7FA4\u91CD\u542F\u5931\u8D25\u4E8B\u6545\u5904\u7406",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69826"
            }, 
        ]
    },
    {
        name: "\u738B\u5929\u5B9C",
        company: "\u5E73\u51EF\u661F\u8FB0",
        title: "TiDB \u793E\u533A\u90E8\u95E8\u67B6\u6784\u5E08",
        links: [
            {
                name: "Flink + TiDB\uFF0C\u4F53\u9A8C\u5B9E\u65F6\u6570\u4ED3\u4E4B\u7F8E",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/182835"
            },
            {
                name: "Flink \u6700\u4F73\u5B9E\u8DF5\u4E4B \u901A\u8FC7 TiCDC \u5C06 TiDB \u6570\u636E\u6D41\u5165 Flink",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68884"
            },
            {
                name: "Flink \u6700\u4F73\u5B9E\u8DF5\u4E4B\u4F7F\u7528 Canal \u540C\u6B65 MySQL \u6570\u636E\u81F3 TiDB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68731"
            },
            {
                name: "TiDB \u76D1\u63A7\u6574\u5408\u65B9\u6848",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93040"
            },
            {
                name: "\u6784\u5EFA\u5B9E\u65F6\u6570\u4ED3 - \u5F53 TiDB \u9047\u89C1 Pravega",
                href: " https://pingkai.cn/tidbcommunity/forum/t/topic/92873"
            },
            {
                name: "\u5982\u4F55\u4F7F\u7528 minio \u8FDB\u884C BR \u5907\u4EFD",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153129"
            },
            {
                name: "\u5982\u4F55\u5728 Kubernetes \u4E0A\u90E8\u7F72 TiDB-Operator \uFF08\u4E0A\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68208"
            },
            {
                name: "\u5982\u4F55\u5728 Kubernetes \u4E0A\u90E8\u7F72 TiDB-Operator \uFF08\u4E0B\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68209"
            },
            {
                name: "\u5982\u4F55\u591A\u4E2A TiDB \u96C6\u7FA4\u5171\u7528\u4E00\u4E2A Grafana",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68177"
            },
            {
                name: "\u901A\u8FC7 ProxySQL \u5728 TiDB \u4E0A\u5B9E\u73B0 SQL \u7684\u89C4\u5219\u5316\u8DEF\u7531",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95252"
            }, 
        ]
    },
    {
        name: "\u59EC\u6C38\u98DE",
        company: "\u5929\u7FFC\u4E91",
        title: "\u9AD8\u7EA7\u540E\u7AEF\u5F00\u53D1\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "CDC \u540C\u6B65\u5230 S3 \u7684\u6545\u969C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95744"
            },
            {
                name: "BR \u5907\u4EFD\u5230 S3 \u65F6 endpoint \u53C2\u6570\u52A0\u76EE\u5F55\u5206\u9694\u7B26\u540E\u7F00\u95EE\u9898\u6392\u67E5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273002"
            },
            {
                name: "TiDB K8s \u5B9A\u65F6\u5907\u4EFD\u72B6\u6001\u5F02\u5E38\u95EE\u9898\u6392\u67E5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/272815"
            },
            {
                name: "TiDB 5.0 \u4E24\u9636\u6BB5\u63D0\u4EA4",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243260"
            },
            {
                name: "\u4E00\u6761 like \u6761\u4EF6\u7684\u6162 SQL \u8BED\u53E5\u4F18\u5316",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243259"
            },
            {
                name: "\u60B2\u89C2\u4E8B\u52A1\u6B7B\u9501\u68C0\u6D4B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243258"
            },
            {
                name: "Placement Rules \u539F\u7406",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243257"
            },
            {
                name: "TiDB K8s \u5220\u9664\u5907\u4EFD\u963B\u585E\u95EE\u9898\u6392\u67E5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243240"
            },
            {
                name: "\u4E00\u4E2A\u8054\u5408\u7D22\u5F15\u4F7F\u7528\u95EE\u9898\u4EE5\u53CA\u4F18\u5316\u65B9\u6848",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/152989"
            },
            {
                name: "TiDB AutoCommit OFF \u95EE\u9898",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95647"
            },
            {
                name: "TiDB \u8D4B\u6743\u95EE\u9898",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93968"
            }, 
        ]
    },
    {
        name: "\u5F20\u653F\u4FCA",
        company: "\u4E2D\u6B27\u57FA\u91D1",
        title: "\u8D44\u6DF1 DBA",
        links: [
            {
                name: "\u6570\u636E\u5E93\u67B6\u6784\u5347\u7EA7\u9009\u578B - TiDB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69516"
            },
            {
                name: "MySQL \u4E0E TiDB \u4E0D\u540C\u7684 DDL \u53D1\u5C55\u5386\u7A0B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69597"
            },
            {
                name: "Raft \u7B97\u6CD5\u6D45\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69645"
            }, 
        ]
    },
    {
        name: "\u91D1\u4F73",
        company: "\u795E\u5DDE\u6570\u7801",
        title: "\u6280\u672F\u603B\u76D1",
        links: [
            {
                name: "SQL\u53EA\u662FCRUD\uFF1F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/94060"
            },
            {
                name: "DELETE Statement\uFF0C\u61C2\u4F60\u4E0D\u5BB9\u6613",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95117"
            },
            {
                name: "\u4ECE TiDB \u4E2D\u5B66\u4E60\u4EE3\u7801\u63D0\u4EA4\u89C4\u8303\u7684\u91CD\u8981\u6027",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95743"
            }, 
        ]
    },
    {
        name: "\u674E\u96F7",
        company: "\u795E\u5DDE\u6570\u7801",
        title: "\u8F6F\u4EF6\u5F00\u53D1\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u4F7F\u7528 TiCDC \u5B9E\u65F6\u540C\u6B65 TiDB \u6570\u636E\u5230\u5907\u7528\u9003\u751F\u73AF\u5883\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/94194"
            },
            {
                name: "\u57FA\u4E8E k8s \u4E0E Chaos Mesh \u6784\u5EFA\u6570\u636E\u5E93\u6DF7\u6C8C\u5B9E\u9A8C\u65E5\u62A5\u7CFB\u7EDF",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/94980"
            },
            {
                name: "TiDB 5.0 \u90E8\u5206\u65B0\u7279\u6027\u8BD5\u7528",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/94854"
            }, 
        ]
    },
    {
        name: "\u9773\u732E\u65D7",
        company: "\u6C7D\u8F66\u4E4B\u5BB6",
        title: "\u9AD8\u7EA7 DBA",
        links: [
            {
                name: "TiDB SQL \u4F18\u5316\u6848\u4F8B\u51E0\u5219",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68396"
            },
            {
                name: "TiDB 4.0 \u57FA\u4E8E Binlog \u7684\u8DE8\u673A\u623F\u96C6\u7FA4\u90E8\u7F72",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93165"
            },
            {
                name: "\u4E00\u6B21\u70ED\u70B9\u95EE\u9898\u6392\u67E5\u7ECF\u5386",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/122815"
            }, 
        ]
    },
    {
        name: "\u5218\u5F3A",
        company: "\u4F5C\u4E1A\u5E2E",
        title: "DBA",
        links: [
            {
                name: "\u4F7F\u7528 pd-recover \u6062\u590Dpd \u591A\u6570\u8282\u70B9\u6545\u969C\u7684\u573A\u666F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93837"
            },
            {
                name: "TiKV \u591A\u526F\u672C\u4E22\u5931\u7684\u6545\u969C\u4FEE\u590D\u6F14\u7EC3",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93934"
            },
            {
                name: "TiDB \u5347\u7EA7\u52305.1.1 \u7684\u6027\u80FD\u8868\u73B0",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/122900"
            }, 
        ]
    },
    {
        name: "\u4F55\u50B2",
        company: "\u795E\u5DDE\u6570\u7801",
        title: "\u6570\u636E\u5E93\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u8FD9\u4E48\u591ATiDB\u8D1F\u8F7D\u5747\u8861\u65B9\u6848\u603B\u6709\u4E00\u6B3E\u9002\u5408\u4F60",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/123082"
            },
            {
                name: "\u5728Windows\u4E0B\u8C03\u8BD5TiDB4PG\u7684\u586B\u5751\u5B9E\u8BB0",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/123326"
            },
            {
                name: "TiDB\u5728X86\u548CARM\u6DF7\u5408\u5E73\u53F0\u4E0B\u7684\u79BB\u7EBF\u90E8\u7F72\u548C\u5347\u7EA7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/152905"
            }, 
        ]
    },
    {
        name: "\u9B4F\u5EFA\u5F3A",
        company: "\u7ADE\u6280\u4E16\u754C",
        title: "DBA",
        links: [
            {
                name: "\u751F\u4EA7\u73AF\u5883 TiDB V5.0.3 \u96C6\u7FA4\u90E8\u7F72",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153455"
            },
            {
                name: "TiDB \u5982\u4F55\u505A\u5230\u65E0\u9650\u6269\u5C55\u548C\u4FDD\u8BC1\u8282\u70B9 id \u552F\u4E00",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153451"
            },
            {
                name: "TiDB 5.0 VS MySQL 8.0 \u6027\u80FD\u5BF9\u6BD4\u6D4B\u8BD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153456"
            },
            {
                name: "TiDB \u96C6\u7FA4 TiKV \u8282\u70B9\u5185\u5B58\u5360\u7528\u8F83\u9AD8\u95EE\u9898\u6392\u67E5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153457"
            },
            {
                name: "TiDB\u96C6\u7FA4\u4E4B\u4E2D\u63A7\u4E0D\u53EF\u7528\uFF0C\u600E\u4E48\u529E\uFF1F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153562"
            }, 
        ]
    },
    {
        name: "\u9093\u521A",
        company: "\u82F1\u7279\u5C14\u6570\u636E\u4E2D\u5FC3\u4E0EAI\u4E8B\u4E1A\u90E8",
        title: "\u5E94\u7528\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "TiDB \u591A Socket \u670D\u52A1\u5668\u6027\u80FD\u6269\u5C55\u95EE\u9898\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95867"
            },
            {
                name: "TiDB \u6027\u80FD\u4F18\u5316\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95731 "
            },
            {
                name: "TiDB \u591ASocket \u670D\u52A1\u5668\u6027\u80FD\u6269\u5C55\u95EE\u9898\u5206\u6790-\u7EED",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/123320"
            }, 
        ]
    },
    {
        name: "\u5B59\u6653\u5149",
        company: "\u5E73\u51EF\u661F\u8FB0",
        title: "Community Development \u56E2\u961F\u8D1F\u8D23\u4EBA\uFF0CTUG \u987E\u95EE\u56E2\u6210\u5458",
        links: [
            {
                name: "\u3010\u5E73\u51EF\u661F\u8FB0 DevCon 2021\u3011TiDB x Flink \u539F\u751F\u5B9E\u65F6\u8BA1\u7B97",
                href: "https://www.bilibili.com/video/BV1tb4y1z7PY"
            },
            {
                name: "\u5E26\u7740\u95EE\u9898\u8BFB TiDB \u6E90\u7801\uFF1AHive \u5143\u6570\u636E\u4F7F\u7528 TiDB \u542F\u52A8\u62A5\u9519",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153499"
            },
            {
                name: "\u7AEF\u5230\u7AEF\u7684\u5B9E\u65F6\u8BA1\u7B97\uFF1ATiDB + Flink \u6700\u4F73\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/182780"
            }, 
        ]
    },
    {
        name: "\u80E1\u7136",
        company: "\u9F99\u6E56\u5730\u4EA7",
        title: "IT \u57FA\u7840\u8D1F\u8D23\u4EBA",
        links: [
            {
                name: "TiDB \u4F18\u5316\u4E4B\u6D88\u5931\u7684\u7EDF\u8BA1\u4FE1\u606F",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95565"
            },
            {
                name: "TiDB \u5B9E\u4F8B\u95F4\u6570\u636E\u540C\u6B65\u4E4B TiCDC \u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/95299"
            },
            {
                name: "TiDB DM \u6269\u5BB9\u548C\u76D1\u63A7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67685"
            }, 
        ]
    },
    {
        name: "\u987E\u5927\u4F1F",
        company: "360",
        title: "\u6570\u636E\u5E93\u8FD0\u7EF4\u4E13\u5BB6",
        links: [
            {
                name: "\u6269\u5BB9 TiKV \u8282\u70B9\u9047\u5230\u7684\u5751",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/183585"
            },
            {
                name: "Tidb duration \u8017\u65F6\u5F02\u5E38\u4E0A\u5347\u6848\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/243253"
            },
            {
                name: "TiCDC \u5B9E\u73B0 TiDB \u5907\u4EFD\u65B9\u6848",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/182918"
            },
            {
                name: "TiFlash \u5C1D\u9C9C\u5C0F\u6848\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/182847"
            }, 
        ]
    },
    {
        name: "\u8D75\u6CB3",
        company: "\u4F01\u67E5\u67E5",
        title: "\u5927\u6570\u636E\u90E8\u95E8 DBA",
        links: [
            {
                name: "\u4E00\u6B21 meet_lock \u544A\u8B66\u5F02\u5E38\u5904\u7406\u8FC7\u7A0B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93906"
            },
            {
                name: "TiDB 4.0 \u751F\u4EA7\u73AF\u5883\u6269\u5BB9 TiKV \u8282\u70B9\u8BE6\u7EC6\u6B65\u9AA4",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/213017"
            },
            {
                name: "TiDB \u76EE\u5F55\u7ED3\u6784\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/152999"
            },
            {
                name: "\u3010TiDB CPU \u4F7F\u7528\u7387\u8FC7\u9AD8\u4E4B\u4E00\u3011Scheduler worker CPU",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93500"
            }, 
        ]
    },
    {
        name: "\u95EB\u5F6C\u5F6C",
        company: "\u8054\u901A\u8F6F\u4EF6\u7814\u7A76\u9662",
        title: "\u6570\u636E\u5E93\u8FD0\u7EF4",
        links: [
            {
                name: "\u60B2\u89C2\u4E8B\u52A1\u52A0\u9501\u9A8C\u8BC1",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273045"
            },
            {
                name: "TiDB \u4E2D\u7684 key \u548C MVCC value \u89E3\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93906"
            },
            {
                name: "TiDB 4.0 \u751F\u4EA7\u73AF\u5883\u6269\u5BB9 TiKV \u8282\u70B9\u8BE6\u7EC6\u6B65\u9AA4",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/213017"
            },
            {
                name: "TiDB5.0.3-ARM \u5E73\u53F0\u6027\u80FD\u6D4B\u8BD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/183732"
            },
            {
                name: "\u901A\u8FC7 label \u8C03\u5EA6\u526F\u672C\u6D4B\u8BD5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/212816"
            }, 
        ]
    },
    {
        name: "\u80E1\u5448\u6E05",
        company: "\u7231\u53EF\u751F",
        title: "\u534E\u4E1C\u533A DBA",
        links: [
            {
                name: "\u4F7F\u7528Zabbix\u76D1\u63A7TiDB\uFF08\u4E8C\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/272890"
            },
            {
                name: "\u5982\u4F55\u7406\u89E3TiDB\u5141\u8BB8\u5E7F\u4E49\u4E0A\u7684\u5E7B\u8BFB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/272797"
            },
            {
                name: "\u4F7F\u7528Zabbix\u76D1\u63A7TiDB\uFF08\u4E00\uFF09",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/272777"
            }, 
        ]
    },
    {
        name: "\u718A\u53CC\u8F89",
        company: "\u963F\u91CC\u4E91\u5B58\u50A8",
        title: "\u57FA\u7840\u5E73\u53F0\u5F00\u53D1",
        links: [
            {
                name: "TiDB-v4.0.x \u652F\u6301 OLAP \u573A\u666F\u7684\u4E00\u4E9B\u5B9E\u8DF5\u7ECF\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68565"
            },
            {
                name: "TiKV \u8282\u70B9\u78C1\u76D8\u8017\u5C3D\u6062\u590D\u7ECF\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68516"
            },
            {
                name: "\u8BB0\u4E00\u6B21\u4F7F\u7528 TiUP \u534A\u81EA\u52A8\u5347\u7EA7 TiDB \u96C6\u7FA4\u7ECF\u9A8C",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/68481"
            }, 
        ]
    },
    {
        name: "\u9AD8\u632F\u5A07",
        company: "\u5E73\u51EF\u661F\u8FB0",
        title: "\u793E\u533A\u6280\u672F\u4E13\u5BB6",
        links: [
            {
                name: "TiDB GC \u4E4B\u76D1\u63A7\u53CA\u65E5\u5FD7\u89E3\u8BFB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67761"
            },
            {
                name: "TiDB GC \u4E4B\u539F\u7406\u6D45\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67760"
            },
            {
                name: "TiDB GC \u4E4B\u5904\u7406\u6848\u4F8B & FAQ",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/67764"
            }, 
        ]
    },
    {
        name: "\u82CF\u5FD7\u9E4F",
        company: "\u5E73\u51EF\u661F\u8FB0",
        title: "DBA",
        links: [
            {
                name: "PD \u5982\u4F55\u8C03\u5EA6 Region",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/242808"
            },
            {
                name: "TiDB run and debug on M1",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/183125"
            },
            {
                name: "TIDB \u4E0D\u5BB9\u6613\u53D1\u73B0\u7684 lightning tidb-backend \u6A21\u5F0F\u5BFC\u5165\u4F18\u5316",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/94981"
            }, 
        ]
    },
    {
        name: "\u79E6\u5929\u723D",
        company: "\u5E73\u51EF\u661F\u8FB0",
        title: "\u9AD8\u7EA7\u89E3\u51B3\u65B9\u6848\u67B6\u6784\u5E08",
        links: [
            {
                name: "TiDB \u96C6\u7FA4\u53EF\u7528\u6027\u589E\u5F3A\uFF1ATiDB 5.0 \u7684 Joint Consensus \u673A\u5236\u4ECB\u7ECD",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273586"
            },
            {
                name: "\u540C\u57CE\u53CC\u4E2D\u5FC3\u81EA\u9002\u5E94\u540C\u6B65\u65B9\u6848\uFF1ADR Auto-Sync \u8BE6\u89E3",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/212812"
            },
            {
                name: "\u4F7F\u7528 TiDB \u65F6\u7684\u8FDE\u63A5\u6C60\u548C\u8D1F\u8F7D\u5747\u8861\u5668\u914D\u7F6E\u7B56\u7565",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/182953"
            },
            {
                name: "TiDB \u6570\u636E\u5E93\u5F00\u53D1\u89C4\u8303",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/93819"
            },
            {
                name: "TiDB \u96C6\u7FA4\u7684\u53EF\u7528\u6027\u8BE6\u89E3\u53CA TiKV Label \u89C4\u5212",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69435"
            },
            {
                name: "\u5982\u4F55\u5728 TiDB \u4E0A\u9AD8\u6548\u8FD0\u884C\u5E8F\u5217\u53F7\u751F\u6210\u670D\u52A1",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69478"
            },
            {
                name: "\u8FD8\u5728\u7528\u53D8\u91CF\u53BB\u5B9E\u73B0\u591A\u7EF4\u5EA6\u5206\u7EC4\u6392\u5E8F\u5417\uFF1F\u4F60 out \u4E86\uFF01",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69437"
            }, 
        ]
    },
    {
        name: "\u859B\u6E2F",
        company: "\u79FB\u52A8\u4E91",
        title: "\u9AD8\u7EA7\u8F6F\u4EF6\u7814\u53D1\u5DE5\u7A0B\u5E08",
        links: [
            {
                name: "\u628A\u4E91\u6570\u636E\u5E93\u670D\u52A1\u53D8\u6210\u9ED1\u76D2\u5B50\uFF1AServerlessDB for HTAP\u4E28Hacking Camp \u8FDB\u884C\u65F6",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153645"
            },
            {
                name: "PD \u542F\u52A8\u4E3B\u6D41\u7A0B\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69399"
            },
            {
                name: "PD \u8C03\u5EA6\u5668\u6A21\u5757",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69397"
            },
            {
                name: "PD \u4E09\u7C7B\u9009\u4E3B\u6D41\u7A0B\u68B3\u7406",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69332"
            },
            {
                name: "PD \u5173\u4E8E TSO \u5206\u914D\u6E90\u4EE3\u7801\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69336"
            },
            {
                name: "PD \u5173\u4E8E ID \u5206\u914D\u7684\u6E90\u7801\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69335"
            },
            {
                name: "PD API \u57FA\u7840\u6846\u67B6\u6E90\u7801\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69334"
            },
            {
                name: "PD \u6A21\u5757\u68B3\u7406",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69329"
            },
            {
                name: "PD \u5BA2\u6237\u7AEF\u6E90\u7801\u5206\u6790",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/69398"
            }, 
        ]
    },
    {
        name: "\u5D14\u6EE2",
        company: "\u9F99\u6E56\u5730\u4EA7",
        title: "DBA",
        links: [
            {
                name: "DM \u591A\u5E93\u5408\u5E76\u81F3 TiDB",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/213029"
            },
            {
                name: "\u6570\u5B57\u5316\u8F6C\u578B\u80CC\u540E\u7684 TiDB\uFF0C\u4EE5\u5730\u4EA7\u884C\u4E1A\u4E3A\u4F8B",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/273771"
            },
            {
                name: "SQL Server \u8FC1\u79FB TiDB \u573A\u666F\u7684\u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/213030"
            }, 
        ]
    },
    {
        name: "\u6F06\u9510",
        company: "\u795E\u5DDE\u6570\u7801",
        title: "TiDB For PG \u9879\u76EE\u6838\u5FC3\u7814\u53D1",
        links: [
            {
                name: "\u5728 TiDB \u4E2D\u5B9E\u73B0\u4E00\u4E2A\u5173\u952E\u5B57\u2014\u2014Parser \u7BC7",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/303135"
            },
            {
                name: "TiDB SQL \u8C03\u4F18\u5B9E\u6218\u2014\u2014\u7D22\u5F15\u95EE\u9898",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/213007"
            },
            {
                name: "\u57FA\u4E8E\u963F\u91CC\u4E91 ECS \u90E8\u7F72\u7684 TiDB 2.1.14 \u5347\u7EA7\u5230 4.0.0-rc \u5B9E\u8DF5",
                href: "https://pingkai.cn/tidbcommunity/forum/t/topic/153306"
            }, 
        ]
    }, 
];
/* harmony default export */ var mva2021 = (mva2021_data);

;// CONCATENATED MODULE: ./src/pages/tug/mva/data/index.js



var mvaData = {
    mva2019: mva2019,
    mva2020: mva2020,
    mva2021: mva2021
};
/* harmony default export */ var mva_data = (mvaData);

;// CONCATENATED MODULE: ./src/pages/tug/mva/index.page.js
function index_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            index_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var getImage = function(filename) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/tug/mva/".concat(filename));
};
var index_page_mva2021 = mva_data.mva2021, index_page_mva2020 = mva_data.mva2020, index_page_mva2019 = mva_data.mva2019;
var MVAs = [
    {
        year: 2021,
        data: index_page_mva2021
    },
    {
        year: 2020,
        data: index_page_mva2020
    },
    {
        year: 2019,
        data: index_page_mva2019
    }, 
];
var welfare = [
    {
        iconUrl: getImage("welfare-icon-1.svg"),
        name: "\u793E\u533A\u8363\u8A89"
    },
    {
        iconUrl: getImage("welfare-icon-2.svg"),
        name: "\u4F1A\u5458\u5B9A\u5236\u793C\u5305"
    },
    {
        iconUrl: getImage("welfare-icon-3.svg"),
        name: "TiDB \u4E13\u5BB6\u517B\u6210\u8BA1\u5212"
    },
    {
        iconUrl: getImage("welfare-icon-4.svg"),
        name: "\u804C\u4E1A\u53D1\u5C55"
    },
    {
        iconUrl: getImage("welfare-icon-5.svg"),
        name: "\u4EBA\u8109\u62D3\u5C55"
    },
    {
        iconUrl: getImage("welfare-icon-6.svg"),
        name: "\u4E2A\u4EBA\u5F71\u54CD\u529B\u5851\u9020"
    }, 
];
var become = [
    {
        iconUrl: getImage("become-icon-1.svg"),
        title: "\u6587\u7AE0",
        summary: "1500+ \u5B57\uFF0C\u7ED3\u6784\u5B8C\u6574\uFF0C\u80FD\u6E05\u695A\u9610\u8FF0\u6280\u672F\u70B9"
    },
    {
        iconUrl: getImage("become-icon-2.svg"),
        title: "TALK",
        summary: "\u9762\u5411 20+ \u53D7\u4F17\u5206\u4EAB\u8BB2\u89E3 TiDB \u53CA TUG \u76F8\u5173\u5185\u5BB9"
    },
    {
        iconUrl: getImage("become-icon-3.svg"),
        title: "\u76F4\u64AD",
        summary: "\u4F5C\u4E3A\u76F4\u64AD\u5609\u5BBE\u5206\u4EAB\u8BB2\u89E3 TiDB \u53CA TUG \u76F8\u5173\u5185\u5BB9"
    }, 
];
var MostValuableAdvocate = function() {
    var ref = (0,react.useState)(MVAs[0].year), year = ref[0], setYear = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "MVA",
                description: "TiDB MOA\uFF08Most Outstanding Advocate\uFF09\u3001TiDB MVA \uFF08Most Valuable Advocate\uFF09\u662F\u4E3A TUG \u8D21\u732E\u9AD8\u8D28\u91CF\u6280\u672F\u5185\u5BB9\u7684 TiDB \u7528\u6237\uFF0C\u4ED6\u4EEC\u5E2E\u52A9\u4ED6\u4EBA\u5145\u5206\u4E86\u89E3 TiDB\uFF0C\u662F TUG \u793E\u533A\u8BA4\u5B9A\u7684 TiDB \u6280\u672F\u5148\u9A71\u8005\u4E0E\u6280\u672F\u9886\u8896\uFF0C\u4EAB\u53D7\u6781\u9AD8\u7684\u793E\u533A\u8363\u8A89\u548C\u6743\u76CA\u3002"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mva_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mva_module_default()).header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                className: (mva_module_default()).header_content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (mva_module_default()).header_content_intro,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mva_module_default()).header_content_intro_logo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: getImage("mva-logo.svg"),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (mva_module_default()).header_content_intro_text,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mva_module_default()).header_content_intro_text_title,
                                                        children: "TUG \u81F3\u9AD8\u8363\u8A89\uFF1AMVA/MOA"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mva_module_default()).header_content_intro_text_summary,
                                                        children: "TUG MVA \uFF08Most Valuable Advocate\uFF09\u3001TUG MOA\uFF08Most Outstanding Advocate\uFF09\u662F\u5728 TUG \u793E\u533A\u91CC\u6D8C\u73B0\u7684\u6280\u672F\u5E03\u9053\u5E08\uFF0C\u4ED6\u4EEC\u5728 TiDB\u3001\u524D\u6CBF\u6570\u636E\u5E93\u4E0E\u5927\u6570\u636E\u6280\u672F\u3001\u70ED\u95E8\u6280\u672F\u8BDD\u9898\u7B49\u9886\u57DF\uFF0C\u901A\u8FC7\u5206\u4EAB\u9AD8\u8D28\u91CF Talk\u3001\u7F16\u5199\u9AD8\u8D28\u91CF\u6280\u672F\u6587\u7AE0\u7B49\u65B9\u5F0F\uFF0C\u4E0E\u793E\u533A\u6210\u5458\u8FDB\u884C\u540C\u4FAA\u5B66\u4E60\u3002\u662F TUG \u793E\u533A\u8BA4\u5B9A\u7684 TiDB \u6280\u672F\u5148\u9A71\u4E0E\u6280\u672F\u9886\u8896\uFF0C\u4EAB\u53D7\u6700\u9AD8\u7684\u793E\u533A\u8363\u8A89\u548C\u6743\u76CA\u3002"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (mva_module_default()).header_content_cup,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: getImage("header-cup.png"),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mva_module_default()).MVAs,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mva_module_default()).MVAs_title,
                                            children: [
                                                year,
                                                " \u5E74\u5EA6 TUG MVA"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YearSwitch, {
                                            value: year,
                                            items: MVAs.map(function(item) {
                                                return {
                                                    name: item.year,
                                                    value: item.year
                                                };
                                            }),
                                            onClick: setYear
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mva_module_default()).MVAs_list,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "center",
                                                gutter: [
                                                    16,
                                                    64
                                                ],
                                                children: MVAs.filter(function(subMva) {
                                                    return subMva.year === year;
                                                })[0].data.map(function(mva, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        xs: 12,
                                                        sm: 12,
                                                        md: 8,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MVAItem, _objectSpread({}, mva))
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mva_module_default()).about,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mva_module_default()).about_left,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: getImage("about-cup.png"),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mva_module_default()).about_right,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (mva_module_default()).about_right_title,
                                                    children: "\u5173\u4E8E MVA"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (mva_module_default()).about_right_detail,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "TiDB \u4F5C\u4E3A\u5168\u7403\u9876\u7EA7\u5F00\u6E90\u9879\u76EE\uFF0C\u53D7\u5230\u5F88\u591A\u7528\u6237\u9752\u7750\uFF0C\u4E5F\u88AB\u8D8A\u6765\u8D8A\u591A\u7684\u6280\u672F\u5DE5\u7A0B\u5E08\u6240\u8BA4\u53EF\uFF0C\u5176\u4E2D\u6709\u5F88\u591A\u4EBA\u5F00\u59CB\u81EA\u53D1\u5730\u8F93\u51FA TiDB \u4F7F\u7528\u6848\u4F8B\u3001\u6700\u4F73\u5B9E\u8DF5\u3001\u539F\u7406\u89E3\u8BFB\u3001\u6570\u636E\u67B6\u6784\u7B49\u5185\u5BB9\u3002\u8FD9\u4E9B\u5185\u5BB9\u6E90\u81EA\u793E\u533A\uFF0C\u4E5F\u56DE\u9988\u4E8E\u793E\u533A\uFF0C\u4FC3\u8FDB\u4E86 TiDB \u6280\u672F\u7684\u4F20\u64AD\u3002\u4E3A\u4E86\u9F13\u52B1\u66F4\u591A\u7528\u6237\u8F93\u51FA\u4F18\u8D28\u6280\u672F\u5185\u5BB9\uFF0C\u611F\u8C22\u4ED6\u4EEC\u5728 TUG \u793E\u533A\u5185\u6240\u505A\u51FA\u7684\u8D21\u732E\uFF0CTUG \u793E\u533A\u53D1\u8D77\u4E86\u201C MVA\u8BA1\u5212 \u201D\uFF0C \u662F\u793E\u533A\u9881\u53D1\u7ED9\u6280\u672F\u4E13\u5BB6\u7684\u4E00\u9879\u8363\u8A89\u8BA4\u8BC1\u3002"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "TUG MVA \uFF08Most Valuable Advocate\uFF09\u3001TUG MOA\uFF08Most Outstanding Advocate\uFF09\u662F\u5728 TUG \u793E\u533A\u91CC\u6D8C\u73B0\u7684\u6280\u672F\u5E03\u9053\u5E08\uFF0C\u4ED6\u4EEC\u5728 TiDB\u3001\u524D\u6CBF\u6570\u636E\u5E93\u4E0E\u5927\u6570\u636E\u6280\u672F\u3001\u70ED\u95E8\u6280\u672F\u8BDD\u9898\u7B49\u9886\u57DF\uFF0C\u901A\u8FC7\u5206\u4EAB\u9AD8\u8D28\u91CF Talk\u3001\u7F16\u5199\u9AD8\u8D28\u91CF\u6280\u672F\u6587\u7AE0\u7B49\u65B9\u5F0F\uFF0C\u4E0E\u793E\u533A\u6210\u5458\u8FDB\u884C\u540C\u4FAA\u5B66\u4E60\u3002\u662F TUG \u793E\u533A\u8BA4\u5B9A\u7684 TiDB \u6280\u672F\u5148\u9A71\u4E0E\u6280\u672F\u9886\u8896\uFF0C\u4EAB\u53D7\u6700\u9AD8\u7684\u793E\u533A\u8363\u8A89\u548C\u6743\u76CA\u3002"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mva_module_default()).welfare,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mva_module_default()).welfare_header,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (mva_module_default()).welfare_header_title,
                                                    children: "\u4E13\u5C5E\u798F\u5229"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (mva_module_default()).welfare_header_link,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyLink/* default */.Z, {
                                                        href: "https://pingkai.cn/tidbcommunity/forum/t/topic/633",
                                                        className: (mva_module_default()).welfare_header_link_button,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowRightOutlined, {}),
                                                            " \u67E5\u770B\u5168\u90E8"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mva_module_default()).welfare_list,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "space-around",
                                                gutter: [
                                                    48,
                                                    48
                                                ],
                                                children: welfare.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WelfareItem, _objectSpread({}, item))
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (mva_module_default()).become,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mva_module_default()).become_widget_line,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getImage("become-line.svg"),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                                    className: (mva_module_default()).become_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mva_module_default()).become_content_title,
                                            children: "\u6210\u4E3A MVA"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mva_module_default()).become_content_summary,
                                            children: [
                                                "\u5728\u4E00\u5E74\u5185\uFF08\u81EA\u7136\u5E74\uFF09\u4E3A TUG \u793E\u533A\u8D21\u732E\u4F18\u8D28\u6280\u672F\u5185\u5BB9\u8FBE\u5230 3 \u4E2A\u53CA\u4EE5\u4E0A\uFF0C\u5373\u53EF\u5F53\u9009 TUG \u5E74\u5EA6 MVA\u3002",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "\u5728\u4E00\u5E74\u5185\uFF08\u81EA\u7136\u5E74\uFF09\u4E3A TUG \u793E\u533A\u8D21\u732E\u4F18\u8D28\u6280\u672F\u5185\u5BB9\u8FBE\u5230 10 \u4E2A\u53CA\u4EE5\u4E0A\uFF0C\u5373\u53EF\u5F53\u9009 TUG \u5E74\u5EA6 MOA\u3002"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mva_module_default()).become_content_list,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                                justify: "space-around",
                                                gutter: [
                                                    48,
                                                    48
                                                ],
                                                children: become.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeMVA, _objectSpread({}, item))
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var index_page = (MostValuableAdvocate);


/***/ }),

/***/ 92593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BecomeMVA_wrapper__rHLDi","title":"BecomeMVA_title__wqGYl","summary":"BecomeMVA_summary__FbFnm"};

/***/ }),

/***/ 60850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MVAItem_wrapper__1Nq_2","main":"MVAItem_main__ux1Wc","hover":"MVAItem_hover__qvBcK","avatar":"MVAItem_avatar__oL_Z9","name":"MVAItem_name__K6v5J","organization":"MVAItem_organization__oVMJw","position":"MVAItem_position__EyWvX","links":"MVAItem_links__7lflu"};

/***/ }),

/***/ 95204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WelfareItem_wrapper__JDcgr","content":"WelfareItem_content__ZD0G8","wireframe":"WelfareItem_wireframe__6ztdc"};

/***/ }),

/***/ 8940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YearSwitch_wrapper__x6yiw","label":"YearSwitch_label__Zq7WN","options":"YearSwitch_options__MZu7F","options_item":"YearSwitch_options_item__LVrtd","options_item_selected":"YearSwitch_options_item_selected__LS6pq"};

/***/ }),

/***/ 5999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mva_wrapper__8BOyb","header":"mva_header__gO22j","header_content":"mva_header_content__V7015","header_content_intro":"mva_header_content_intro__TydWC","header_content_intro_logo":"mva_header_content_intro_logo__zyD2a","header_content_intro_text":"mva_header_content_intro_text__zUgYa","header_content_intro_text_title":"mva_header_content_intro_text_title__E0MmG","header_content_intro_text_summary":"mva_header_content_intro_text_summary__hnrhQ","header_content_cup":"mva_header_content_cup__zLkrB","header_widget_1":"mva_header_widget_1__N77ot","header_widget_2":"mva_header_widget_2__ks5Cm","header_widget_3":"mva_header_widget_3__WN6_U","header_widget_line":"mva_header_widget_line__7z5p9","MVAs":"mva_MVAs__9vrxv","MVAs_title":"mva_MVAs_title__tFOmQ","MVAs_list":"mva_MVAs_list__1rP_8","about":"mva_about__qfvtF","about_left":"mva_about_left__yQS76","about_right_title":"mva_about_right_title__GbWUN","about_right_detail":"mva_about_right_detail__NRYRf","welfare":"mva_welfare__FGSv2","welfare_header":"mva_welfare_header__JQ0aw","welfare_header_title":"mva_welfare_header_title__IrI_3","welfare_header_link_button":"mva_welfare_header_link_button__P0e7W","welfare_list":"mva_welfare_list__F2ahH","become":"mva_become__XtdSA","become_widget_line":"mva_become_widget_line__tUnmM","become_content_title":"mva_become_content_title__II4xx","become_content_summary":"mva_become_content_summary__5wjyb","become_content_list":"mva_become_content_list__OrIf4"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(3510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);